
export default {
  inject: ['maintenanceMessage']
}
